import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import type { ModalProps as MuiModalProps } from "@mui/material/Modal";
import { default as MuiModal } from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  maxWidth: "min(calc(100vw - 30px), 500px)",
  maxHeight: "calc(100vh - 48px)",
  overflowY: "auto",
  boxShadow: 24,
  borderRadius: "15px",
  py: 10,
  p: 4,
  "@media (max-width: 600px)": {
    top: "auto",
    bottom: 0,
    left: 0,
    right: 0,
    transform: "none",
    maxWidth: "100%",
    width: "100%",
    maxHeight: "92vh",
    borderRadius: "16px 16px 0 0",
    p: 3,
  },
};

interface ModalProps extends MuiModalProps {
  width?: number | string;
}

export default function Modal({ open = true, children, width, ...props }: ModalProps) {
  return (
    <MuiModal
      open={open}
      closeAfterTransition
      disableAutoFocus={true}
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
      {...props}
    >
      <Fade in={open}>
        <Box sx={{ ...style, ...(width ? { width, maxWidth: `min(calc(100vw - 30px), ${typeof width === "number" ? `${width}px` : width})` } : {}) }}>
          {children}
        </Box>
      </Fade>
    </MuiModal>
  );
}
